import React from 'react';
import approveIcon from './images/aprove-icon.svg';
import Image from 'app/Components/Shared/Image/image';
import arrowLeftIcon from './images/arrow-left-icon.svg';
const DigitalSignature = (props) => {
  return (
    <div className='energy-sale-digital-signature'>
      {props.isSignDigitalSignature ? (
        <>
            <Image src={approveIcon} alt='approve-icon' className='approve-icon'/>
            <div className='is-sign'>הטופס נחתם</div>
        </>
      ) : (
        <div
          onClick={props.onClick}
          className={`${props.disable ? 'disabled' : ''}`}
        >
          <Image src={arrowLeftIcon} alt='arrow-left-icon' className='arrow-left-icon'/>
          <span className='link-text'>לחתימה על טופס ייפוי כוח</span>
        </div>
      )}
    </div>
  );
};

export default DigitalSignature;
